import { request, requestBlob } from '@/lib/api'

export interface AttachmentView {
  id: string
  entityType: string
  entityId: string
  fileName: string
  contentType: string | null
  sizeBytes: number
  checksumSha256: string | null
  scanStatus: 'pending' | 'clean' | 'infected' | 'failed'
  scanCompletedAt: string | null
  scanMessage: string | null
  uploadedAt: string
  downloadable: boolean
}

export function fetchAttachments(
  entityType: string,
  entityId: string,
  signal?: AbortSignal,
): Promise<AttachmentView[]> {
  const query = new URLSearchParams({ entityType, entityId })
  return request<AttachmentView[]>(`/attachments?${query}`, { signal })
}

export function uploadAttachment(
  entityType: string,
  entityId: string,
  file: File,
): Promise<AttachmentView> {
  const body = new FormData()
  body.set('file', file)
  const query = new URLSearchParams({ entityType, entityId })
  return request<AttachmentView>(`/attachments?${query}`, {
    method: 'POST',
    rawBody: body,
  })
}

export async function downloadAttachment(attachment: AttachmentView): Promise<void> {
  const blob = await requestBlob(`/attachments/${attachment.id}/content`)
  const url = URL.createObjectURL(blob)
  try {
    const link = document.createElement('a')
    link.href = url
    link.download = attachment.fileName || 'file'
    link.click()
  } finally {
    URL.revokeObjectURL(url)
  }
}
